import { TFunction } from 'i18next'
import { ChargingSessionModel } from '../models/charging-sessions.model'

type AuthenticationLabelProps = {
  rfid: string | null | undefined
  cardName: string | undefined
  authenticationMethod: ChargingSessionModel['authentication']['authenticationMethod']
  isAuthenticated: boolean
  t: TFunction
}

/**
 * To populate authentication(rfid) filter dropdown, we generate a proper dropdown option label.
 *
 * In case charging card name is not set up, we display just the charging card id.
 * In case charging card name is set up, we display both charging card name and charging card id.
 */
export const getAuthenticationLabel = ({ rfid, cardName, authenticationMethod, isAuthenticated, t }: AuthenticationLabelProps): string => {
  if (!isAuthenticated) {
    return t('emobility.chargingSession.noAuthentication')
  }

  const label = t(`emobility.chargingSession.authentication-info-label.${authenticationMethod}`)

  if (cardName) {
    return t('emobility.chargingSession.authenticationInfoCardName', {
      cardName,
      label,
      rfid,
    })
  }

  return t('emobility.chargingSession.authenticationInfoRfid', { label, rfid })
}
